<template>
  <div class="quotes-apply-terms-page">
    <div class="content list-wrapper">
      <div class="content-word">
        <div class="terms">
          <div class="title">{{terms.title}}</div>
          <div class="sub-title">{{terms.subTitle}}</div>
          <div class="terms-content" v-html="terms.item"></div>
          <br>
          <div class="agree-check">
            <el-checkbox v-model="agreeConf.checked" :disabled="agreeConf.disabled"
              :size="agreeConf.size"
              @change="onChange(agreeConf.name, agreeConf.checked, $event)">{{$t('quotes.consentRules')}}</el-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button :loading="submitbtnLoading" type="primary" :disabled="!agreeConf.checked" @click="clickHandle">{{btntext}}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    submitbtnLoading: {
      type: Boolean,
      default: false
    },
    btntext: {
      type: String,
      default: ''
    },
    terms: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      disabledSubmit: true,
      agreeConf: {
        checked: false,
        name: 'agree0',
        size: 'md',
        disabled: false,
        introduction: '选中状态'
      }
      // terms: this.$t('quotes.terms')
    }
  },
  mounted () {
  },
  computed: {
    popUpViewHight () {
      return document.documentElement.clientHeight * 0.65 + 'px'
    }
  },
  methods: {
    onChange (name, checked) {
      console.log('checked>>>>>', checked)
    },
    clickHandle () {
      this.$router.push({
                path: '/QuotesApplyForm',
                query: {
                  includesUs: 'no'
                }
              })
    },
    submitApply () {
      if (!this.agreeConf.checked) {
        return this.$message.error('请阅读条款及申明')
      }
      this.$emit('nextStepHandle', 'quotesApplyTerms', { agree: this.agreeConf.checked })
    }
  }
}
</script>
<style lang="scss">

</style>
